import * as DataGenerator from 'data-generator-retail';

export type ThemeName = 'light' | 'dark';

/**
 * Layout types for categories
 */
export enum LayoutType {
  BANNER = 'banner',
  VIDEO = 'video',
  SIMPLE_LIST = 'simpleList',
  GALLERY_SPLIT = 'gallerySplit',
  HERO_AND_LIST = 'heroAndList',
  GENRE = 'genre',
  GRID = 'grid',
}

/**
 * Categories are fetched by clients with a hardcoded `version` equality filter, so a new
 * layout only reaches clients that explicitly query for its version — old app builds keep
 * querying version 1 and never see it. Bump this when a layout needs client support that
 * isn't out yet; everything else stays on the version clients already query for.
 */
export const CATEGORY_VERSION_BY_LAYOUT: Partial<Record<LayoutType, number>> = {
  [LayoutType.GRID]: 2,
};

export const categoryVersionForLayout = (layoutType: LayoutType): number =>
  CATEGORY_VERSION_BY_LAYOUT[layoutType] ?? 1;

export type Category = DataGenerator.Category;
export type Product = DataGenerator.Product;
export type Customer = DataGenerator.Customer;
export type Order = DataGenerator.Order;
export type Invoice = DataGenerator.Invoice;
export type Review = DataGenerator.Review;
export type BasketItem = DataGenerator.BasketItem;

export enum ChannelActionType {
  HANDS_UP = 'handsUp',
  CHAT = 'chat',
  DISABLED = 'disabled',
}

declare global {
    interface Window {
        restServer: any;
    }
}
